import * as React from 'react';

import { ApplicationState, ConnectedReduxProps } from '../../../../store';
import { ClauseResponse, GuaranteeResponse, InsuredRiskResponse } from '../../../../store/details/policy/model';
import { ClauseInformation } from '../../../custom/clause-information';
import GuaranteeInformation from '../../../custom/guarantee-information';
import { StaticInformation } from '../../../custom/static-information';
import { connect } from 'react-redux';
import styles from './policy.module.css';
import { Policy as PolicyType } from '../../../../store/details/policy/types';
import { Ii18n } from '../../../../store/utils/contracts/i18n.interface';
import { getI18n } from '../../../../store/utils/i18n/strings.manager';
import { Currency } from '../../../../store/shared/types';
interface PropsFromState {
  readonly policy: PolicyType;
  readonly insuredRisk: InsuredRiskResponse;
  readonly clauses: ClauseResponse[];
  readonly guarantees: GuaranteeResponse[];
  readonly currentLanguage: string;
  readonly policyHolderLanguageTC: string;
}

type AllProps = PropsFromState & ConnectedReduxProps;
interface IndexedProps extends AllProps {
  [key: string]: any;
}

class Policy extends React.Component<IndexedProps> {
  private localization: Ii18n;
  constructor(props: IndexedProps) {
    super(props);
    this.localization = getI18n();
  }

  private extractInformation(key: string) {
    const returnValue: { [key: string]: string } = {};

    Object.keys(this.props[key])
      .filter(x => this.props[key][x] !== null && this.props[key][x] !== undefined)
      .forEach(x => {
        returnValue[x] = this.props[key][x];
      });

    return returnValue;
  }

  render() {
    return (
      <div className={styles.container}>
        <div className={styles.static}>
          <div className={styles.staticContent}>
            <StaticInformation translation='details.policy.info' headerText={this.localization.get('details.policy.policy')} fiftySplit={true}
              information={{
                'insurerPartyName': this.props.policy.insurerPartyName,
                'contractNumber': this.props.policy.contractNumber,
                'contractClassification': this.props.policy.contractClassification,
                'contractName': this.props.policy.contractName,
                'conditions': this.props.policy.conditions,
                'legalExcessAmount': new Currency(this.props.policy.legalExcessAmount, '', '€'),
                'dateOfCommencement': this.localization.getFormatedDate(this.props.policy.dateOfCommencement, this.props.currentLanguage),
                'dateOfExpiration': this.localization.getFormatedDate(this.props.policy.dateOfExpiration, this.props.currentLanguage),
                'indirectLossesPercentage': this.props.policy.indirectLossesPercentage,
                'buildingIndexSubscription': this.props.policy.buildingIndexSubscription,
                'buildingIndexClaim': this.props.policy.buildingIndexClaim,
                'consumptionIndexSubscription': new Currency(this.props.policy.consumptionIndexSubscription / 100, '', ''),
                'consumptionIndexClaim': new Currency(this.props.policy.consumptionIndexClaim / 100, '', ''),
                'DVVStarsUsed': this.props.policy.DVVStarsUsed,
                'EnglishFranchise': this.props.policy.EnglishFranchise
              }} />
            <StaticInformation translation='details.policy.insuredRisk' headerText={this.localization.get('details.policy.insuredRisk')} information={this.extractInformation('insuredRisk')} fiftySplit={true} />
          </div>
        </div>
        <div className={styles.dynamic}>
          <h2 className={styles.headerText}>{this.localization.get('details.policy.clauses')}</h2>
          <div className={styles.clauses}>
            <ClauseInformation translation='details.policy.clause' headerText={this.localization.get('details.policy.clauses')} headerColor='#aa0024' information={this.props.clauses} />
          </div>
          <div className={styles.dynamicInfoSpacer}></div>
          <h2 className={styles.headerTextWithTopLine}>{this.localization.get('details.policy.guarantees')}</h2>
          <div className={styles.guarantees}>
            <GuaranteeInformation translation='details.policy.guarantee' headerText={this.localization.get('details.policy.guarantees')} headerColor='#aa0024' information={this.props.guarantees} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ details: { detailsPolicy }, shared }: ApplicationState): PropsFromState => ({
  policy: detailsPolicy.policy,
  insuredRisk: detailsPolicy.insuredRisk,
  clauses: detailsPolicy.clauses,
  guarantees: detailsPolicy.guarantees,
  currentLanguage: shared.currentLanguage,
  policyHolderLanguageTC: detailsPolicy.policy.policyHolderLanguageTC,
});

export default connect(mapStateToProps)(Policy);
